import _ from 'lodash';
import { INIT_ROOT, UPDATE_POSTAL_CODE } from '../actionTypes';

export default function params(state, action) {
  switch (action.type) {
    case INIT_ROOT:
      return action.payload.params;
    case UPDATE_POSTAL_CODE:
      return _.assign({}, state, action.payload);
    default:
      return state || {};
  }
}
